import React from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';

import ActivityListFilterField from './ActivityListFilterField';
import ActivityListFilterInput from './ActivityListFilterInput';
import ActivityListSortField from './ActivityListSortField';
import styles from './ActivityListOptions.module.scss';

const ActivityListOptions = () => {
  const mediumWidth = useMediaQuery('(min-width:700px)');

  return (
    <div className={styles.container}>
      <div className={styles.actions}>
        <ActivityListFilterField />
        <ActivityListSortField />
      </div>

      <div className={styles.filterInputContainer}>
        {mediumWidth && <ActivityListFilterInput className={styles.filterInput} />}
      </div>
    </div>
  );
};

export default ActivityListOptions;
